@use '~/assets/css/media/media.scss' as *;
@use '~/assets/css/colors/colors.scss' as *;

.airport-card {
    position: relative;

    &__back-button {
        display: flex;
        align-items: center;
        position: static;
        width: fit-content;
        margin-bottom: 12px;
        background: transparent;
        border: none;
        font-size: 16px;
        cursor: pointer;
        z-index: 101;
        font-weight: 600;
        color: $color-blue-button;

        @media (--medium) {
            position: absolute;
            top: 0;
            left: 0;
            margin-bottom: 0;
        }

        &:hover {
            text-decoration: underline;
        }
    }

    margin-top: 32px;

    .white-block {
        margin-top: 16px;
        padding: 16px;

        @media (--large) {
            padding: 42px;
            padding-left: 84px;
            padding-right: 84px;
        }
    }

    &__title {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        justify-content: center;
        gap: 6px;
        margin: 0 auto;
        font-weight: 700;
        font-size: 24px;
        text-align: center;

        &-code {
            color: $color-blue-button;
            white-space: nowrap;
        }

        &-separator {
            color: #11192b66;
            font-weight: 500;
        }
    }

    &__subtitle {
        margin: 10px auto 0;
        color: #11192B99;
        font-weight: 400;
        text-align: center;
        font-size: 14px;
    }

    &__overview {
        margin-bottom: 28px;
        padding-bottom: 24px;
        border-bottom: 1px solid #e5e5e5;
    }

    &__overview-title {
        margin: 0 0 10px;
        font-size: 20px;
        font-weight: 600;
    }

    &__overview-text {
        margin: 0;
        color: #11192BCC;
        font-size: 14px;
        line-height: 1.6;
    }

    &__charter {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 28px;
        padding: 18px;
        border: 1px solid rgb(11 61 148 / 14%);
        border-radius: 12px;
        background: #f6f8fd;

        @media (--medium) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        h2 {
            margin: 0;
            color: #11192b;
            font-size: 18px;
        }

        p {
            margin: 6px 0 0;
            color: #11192b99;
            font-size: 13px;
            line-height: 1.5;
        }
    }

    &__charter-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    &__charter-primary,
    &__charter-secondary {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 38px;
        height: auto;
        padding: 8px 12px;
        border: 1px solid $color-blue-button;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.35;
        text-align: center;
        cursor: pointer;
    }

    &__charter-primary:hover,
    &__charter-primary:focus-visible,
    &__charter-secondary:hover,
    &__charter-secondary:focus-visible {
        text-decoration: none;
    }

    &__country-link {
        display: inline-flex;
        margin-top: 12px;
        font-size: 14px;
    }

    &__left {
        width: 100%;
    }

    &__right {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 24px 48px;
        width: 100%;
        min-width: 0;

        @media (--medium) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        &_handlers {
            .airport-card__info-column {
                min-width: 0;
            }
        }
    }

    &__label {
        display: inline-block;
        background: #ffe9dc;
        color: #FA742D;
        font-weight: 500;
        font-size: 14px;
        border-radius: 6px;
        padding: 2px 8px;
        margin-bottom: 22px;
    }

    &__section {
        position: relative;
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 24px;
        margin-bottom: 28px;

        &-wrapper {
            display: grid;
            grid-template-columns: minmax(0, 1fr);
            gap: 20px;

            @media (--large) {
                grid-template-columns: 300px minmax(0, 1fr);
                gap: 38px;
            }
        }

        &-title {
            grid-column: 1 / -1;
            margin: 0;
            font-size: 20px;
            font-weight: 600;
        }
    }

    &__info-row {
        min-width: 0;
        flex-shrink: 0;
        width: 100%;
        display: flex;
        font-size: 14px;
        margin-bottom: 8px;
    }

    &__info-column-title {
        margin: 0 0 24px;
        font-weight: 700;
        font-size: 14px;
    }

    &__label-item {
        color: #11192B66;
        font-size: 14px;
        font-weight: 500;
        min-width: 76px;
    }

    &__runway {
        grid-column: 1 / -1;
        margin-top: 14px;
    }

    &__runway-title {
        margin: 0 0 12px;
        font-size: 14px;
        font-weight: 700;
    }

    &__value {
        min-width: 0;
        margin-left: 4px;
        font-size: 14px;
        font-weight: 600;
        overflow-wrap: anywhere;
    }

    &__runway-row {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
        margin-bottom: 6px;

        @media (--small) {
            grid-template-columns: repeat(4, minmax(0, 1fr));
        }

        &_header {
            display: none;

            @media (--small) {
                display: grid;
            }
        }

        .airport-card__value {
            margin-left: 0;
        }
    }

    a:where(:not(.button)) {
        font-weight: 500;
        color: $color-blue-button;

        &:hover {
            text-decoration: underline;
        }
    }

    &__runway-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-width: 0;
    }

    &__runway-mobile-label {
        display: block;
        margin-bottom: 4px;
        color: #11192B66;
        font-size: 12px;
        font-weight: 500;

        @media (--small) {
            display: none;
        }
    }

    &__related {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 24px;

        & + & {
            margin-top: 28px;
            padding-top: 28px;
            border-top: 1px solid #e5e5e5;
        }

        &-group {
            h2 {
                margin: 0;
                font-size: 18px;
            }

            > p {
                margin: 8px 0 0;
                color: #11192B99;
                font-size: 13px;
                line-height: 1.5;
            }

            ul {
                display: grid;
                gap: 8px;
                margin: 14px 0 0;
                padding: 0;
                list-style: none;
            }

            li a:link,
            .airport-card__source-item {
                display: flex;
                flex-direction: column;
                gap: 3px;
                padding: 11px 12px;
                border: 1px solid rgb(11 61 148 / 14%);
                border-radius: 8px;
            }

            li a:link {
                &:hover,
                &:focus-visible {
                    border-color: $color-blue-button;
                    background: #f8fbff;
                    text-decoration: none;
                }
            }

            li strong {
                font-size: 14px;
            }

            li span {
                color: #11192B99;
                font-size: 12px;
                font-weight: 500;
            }
        }
    }

    &__company {
        width: 100%;
        max-width: 300px;
        margin-bottom: 0;

        @media (--medium) {
            width: 100%;
        }
    }
}
